import {
  GET_GEOLOCATION_V2_PENDING,
  GET_GEOLOCATION_V2_REJECTED,
  GET_GEOLOCATION_V2_FULFILLED,
} from "../../constants/geolocationV2";

const geolocationV2 = (state = {}, action) => {
  switch (action.type) {
    case GET_GEOLOCATION_V2_PENDING:
      return { ...state, loading: true, error: false, success: false };
    case GET_GEOLOCATION_V2_REJECTED:
      return { ...state, loading: false, error: true, success: false };
    case GET_GEOLOCATION_V2_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: action.payload.data,
      };
    default:
      return state;
  }
};

export default geolocationV2;
